import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../_model/ApiResponse';
import { File } from '../_model/File';

@Injectable({
  providedIn: 'root'
})
export class AbsReportService extends BaseService {

constructor(private httpClient: HttpClient) {
  super(httpClient);
 }

 
getReport(absenceReport: ReportRequest):Observable<ApiResponse> 
{
  return this.post<ApiResponse>('/api/v1/report',absenceReport);
}


}

export class ReportRequest {
  reportId: number;
  parameters: ReportParameterDto[] = [];
}

export class ReportParameterDto {
  name: string;
  value: string;
}
